module.exports = __webpack_public_path__ + "img/personalizedPlatesCarouselImage.00c9211d.png";